"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSBridgeApp = void 0;
var tslib_1 = require("tslib");
var controllers_1 = require("./controllers");
var Subscribe_1 = require("../shared-utils/Subscribe");
var WebViewTypeEnum_1 = require("../typings/WebViewTypeEnum");
var defaultOptions = {
    timeout: 6000,
};
/**
 * App 客户端（iOS [WKWebView](https://developer.apple.com/documentation/webkit/wkwebview) 或 Android [WebView](https://developer.android.google.cn/guide/webapps/webview)）JSBridge。
 */
var JSBridgeApp = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(JSBridgeApp, _super);
    function JSBridgeApp(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.options = Object.assign(defaultOptions, options);
        var userAgent = navigator.userAgent;
        if (!/realsee/i.test(userAgent)) {
            console.warn('未知容器：此版本 `jsBridge` 不支持当前 WebView 容器 ... ');
        }
        _this.webViewType = /android/i.test(userAgent) ? WebViewTypeEnum_1.WebViewTypeEnum.WebView : WebViewTypeEnum_1.WebViewTypeEnum.WKWebview;
        _this.callAndListen('common/webViewState', function (webviewState) {
            _this.emit('webViewStateChange', webviewState);
        });
        _this.callAndListen('common/webViewError', function (errorInfo) {
            _this.emit('error', errorInfo);
        });
        return _this;
    }
    JSBridgeApp.prototype.ready = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, controllers_1.controller.checkReady(this.options.timeout)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.callAndBackfeed = function (schemeUrl) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, controllers_1.controller.callAndBackfeed(schemeUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.callAndListen = function (schemeUrl, callback) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, controllers_1.controller.callAndListen(schemeUrl, callback)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.setLeftTopBackButton = function (enable) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.webViewType === WebViewTypeEnum_1.WebViewTypeEnum.WebView) {
                            return [2 /*return*/, [true, null]];
                        }
                        return [4 /*yield*/, this.callAndBackfeed("common/setLeftTopBackButton?enable=" + (enable ? 1 : 0))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.getBangsHeight = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed('common/getBangsHeight')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.shock = function (duration) {
        if (duration === void 0) { duration = 4; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/shock?duration=" + duration)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.minimize = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/minimize")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.loadProgress = function (progress) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        progress = progress < 0 ? 0 : (progress > 100 ? 100 : progress);
                        return [4 /*yield*/, this.callAndBackfeed("common/loadProgress?progress=" + progress)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.closeLoading = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/closeLoading")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.setOrientation = function (orientation) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/setOrientation?orientation=" + orientation)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.keepScreenLight = function (enable) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/keepScreenLight?enable=" + (enable ? 1 : 0))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.closeWebView = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/closeWebView")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.openWebView = function (url, way) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/openWebView?way=" + way + "&url=" + encodeURIComponent(url))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.saveImage2Album = function (base64) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/saveImage2Album?base64=" + base64)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.actionShare = function (shareConfig) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/actionShare?json=" + JSON.stringify(shareConfig))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.getDeviceInfo = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/getDeviceInfo")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.getUserInfo = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/getUserInfo")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.getWebViewState = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/getWebViewState")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.login = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/login")];
                    case 1:
                        res = _a.sent();
                        if (!res[0]) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUserInfo()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, res];
                }
            });
        });
    };
    JSBridgeApp.prototype.logout = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/logout")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.detectMicro = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.callAndBackfeed("common/detectMicro")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.preload = function (urls) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urls = urls.map(function (url) {
                            if (url.startsWith('//')) {
                                return 'https:' + url;
                            }
                            return url;
                        });
                        return [4 /*yield*/, this.callAndBackfeed("common/preload?urls=" + JSON.stringify(urls))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSBridgeApp.prototype.createCacheProxyUrl = function (urls) {
        var _this = this;
        urls = Array.isArray(urls) ? urls : [urls];
        var userAgent = window.navigator.userAgent;
        // 不支持缓存代理
        if (!/supportCache/i.test(userAgent)) {
            return urls;
        }
        var proxyCache = function (url) {
            if (_this.webViewType === WebViewTypeEnum_1.WebViewTypeEnum.WKWebview) {
                return url.replace(/https*:/, '').replace(/\/\//, 'realseeproxycache://');
            }
            else if (_this.webViewType === WebViewTypeEnum_1.WebViewTypeEnum.WebView) {
                return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'realseeproxycache=1';
            }
            return url;
        };
        return urls.map(proxyCache);
    };
    return JSBridgeApp;
}(Subscribe_1.Subscribe));
exports.JSBridgeApp = JSBridgeApp;
//# sourceMappingURL=index.js.map